export const MODEL_CLAIM_SELECTION_TYPE_ADVANCE = 'ADVANCE';
export const MODEL_CLAIM_SELECTION_TYPE_BASIC = 'BASIC';

export const MODEL_SEARCH_REQUEST_TYPE_CLAIMS = 'CLAIMS';
export const MODEL_SEARCH_REQUEST_TYPE_GRIDSEARCH = 'GRIDSEARCH';
export const MODEL_SEARCH_REQUEST_TYPE_FORMSEARCH = 'FORMSEARCH';
